module.exports = __webpack_public_path__ + "static/media/sbi.128c90c2.png";